import React from 'react';

const LOADER_LOGO_URL = 'https://stg-admin.gkcloud.in/storage/settings/backend_favicon_1739509041.png';

function FullScreenLoader() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <img
        src={LOADER_LOGO_URL}
        alt="Loading..."
        style={{
          width: '100px',
          height: 'auto',
          animation: 'pulse 1.5s infinite',
        }}
      />
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
}

export default FullScreenLoader;
